import React from 'react';
import './css/Home.css'; // Assuming you have a CSS file for additional styling

const Home = () => {
  return (
    <div className="home-container">
      <div className="row">
        <div className="col-md-6 image-container">
          <img src="/Images/p1.png" alt="Description" className="img-fluid" />
          <div className="thinking-cloud">Do you like it?</div>
        </div>
        <div className="col-md-6 text-container">
          <div className="text-content">
            <h1>Welcome to My Profile</h1>
            <p>
            Experienced DevOps Engineer with 10+ years in automating and optimizing cloud and on-premises deployments. Skilled in AWS, Azure, Kubernetes, Docker, Terraform, Ansible, ELK, Grafana, Loki, Linux, and Windows. Proficient in PowerShell, Shell Scripting, and Python to streamline CI/CD, IaC, and system monitoring. Passionate about automation, reliability, and performance optimization to enhance software delivery and operational efficiency.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;